import { crudRequest, crudRequestGet } from '@/services/api';
import { getToDay } from '@/utils/date';
import dataJson from './data.json'

export default {
  namespace: 'centerroutetrajectoryflow',
  state: {
    dataList: [],
    waybillNo: '',
    numberNo: '50001963398400060001'
  },

  effects: {
    *getData(_, { call, put, select }) {
      const { numberNo } = yield select(({ centerroutetrajectoryflow }) => centerroutetrajectoryflow)
      const param = {}
      if (numberNo.length === 12) {
        param.waybillNo = numberNo
      } else if (numberNo.length === 20) {
        param.subBillNo = numberNo
      }
      // const data = yield crudRequest('/api/forecastpath/queryGroupVersion', param)
      // console.log('data', data)
      yield put({ type: 'updateState', payload: { dataList: dataJson } })
    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    searchParamsUpdate(state, { payload }) {
      const searchParams = { ...state.searchParams, ...payload };
      return { ...state, searchParams };
    },
    resetSearchParam(state) {
      return { ...state, searchParams: { ...params } };
    },
  },
};
